import React from 'react'
import "../assets/css/about.css"
import SubTitle from "./SubTitle";
import ExDataTable from "./ExDataTable";
import Tools from './Tools';
import Badge from './Badge';
import SectionTitle from './SectionTitle';
import SecParagraph from './SecParagraph';
import Footer from './Footer';

function Aboutpage() {
  return (
    <div className="about-sec">
      <div className="ab-hero">
         <h2>Dilip Suthar</h2>
         <h4>Full Stack Developer</h4>
         <p>
         We create modern digital solutions crafted with precision, purpose, and creativity. Our focus is delivering seamless user experiences, strong performance, and clean design. From simple ideas to full-scale products, we turn concepts into meaningful results through thoughtful planning, smart development, and reliable execution that truly supports your growth.
         </p>
      </div>

      <div className="ab-ex-list-sec">
        <div className="ab-ex-list">
           <h4>3+</h4>
           <p>Years Experience</p>
        </div>
        <div className="ab-ex-list">
          <h4>23+</h4>
          <p>Project Completed</p>
        </div>
        <div className="ab-ex-list">
          <h4>28+</h4>
          <p>Know Technologies</p>
        </div>
        <div className='ab-ex-list'>
          <h4>80%</h4>
          <p>Success Rate</p>
        </div>

      </div>

        <Badge title="Resume" />
          <SectionTitle sectitle="Education and practical experience" />
          <SecParagraph data="I have worked on live projects with companies like Bigxtech and Future Core Innovation, gaining hands-on experience in web development. Currently, I run Skilltech Academy, where I provide online and offline courses to help aspiring developers grow their skills." />


       <div className="ex-sec">
            <SubTitle subtitle="My education" />
            <ExDataTable
              year="2017-2019"
              extitle="9th - 10th Grade"
              exdesc="Arya Samaj School"
              exdata="Focused on foundational academic subjects, improved logical thinking, and participated in school activities and basic computer learning."
            />
            <ExDataTable
              year="2019-2021"
              extitle="11th - 12th Grade"
              exdesc="G.S.S.S Sumerpur"
              exdata="Completed senior secondary education with academic excellence, stream focus, practical skills, and preparation for competitive and entrance examinations."
            />
            <ExDataTable
              year="2021-2025"
              extitle="B.Tech [ CSE ]"
              exdesc="CLG Institute of Engineering & Technology"
              exdata="Studied core computer science subjects, including programming, data structures, web development, and software engineering with hands-on project experience."
            />
          </div>

          <div className="ex-sec">
            <SubTitle subtitle="Work experience" />
            <ExDataTable
              year="Nov 2022 - Jan 2024"
              extitle="Frontend Developer Intern"
              exdesc="Bigxtech"
              exdata="Worked on real-world web projects using HTML, CSS, JavaScript, and React. Gained hands-on experience in UI/UX development."
            />

            <ExDataTable
              year="Mar 2024 - Oct 2024"
              extitle="Frontend Developer"
              exdesc="Future Core Innovations"
              exdata="Developed and maintained responsive websites and landing pages. Improved performance and collaborated with backend team for full integration."
            />

            <ExDataTable
              year="Nov 2024 - Present"
              extitle="Web Developer"
              exdesc="Vistavoyage Solutions Pvt Ltd"
              exdata="Building dynamic travel websites, integrating APIs, and handling frontend-to-backend communication for real-time booking and user experience."
            />
          </div>
    <Badge title="Tools" />
          <SectionTitle sectitle="My favourite tools" />
          <Tools/>
          <Footer/>
        
          
    </div>
  )
}

export default Aboutpage
